export enum UpdateTokenEvent {
  SUCCESS = '0',
  EXPIRED_ERROR = '1', // error of updating an expired token
  MANUAL_ERROR = '2', // update error after click refresh button
  INTERVAL_ERROR = '3', // update error in background task launched after EXPIRED_ERROR
  IN_PROGRESS = '4',
  TIMEOUT = '5' // timeout error sent when UpdateTokenAction.UPDATE_EXPIRED action not executed in given time
}
